<template>
  <div>
    <VRow>
      <VBtn
        class="mb-2 header__link text-capitalize d-flex align-items-center"
        color="secondary"
        text
        data-test="night-card-signup-back"
        @click="$emit('back')"
      >
        <div class="d-flex align-items-center">
          <VIcon class="mr-2">
            mdi-arrow-left
          </VIcon>
          <span
            v-if="!$vuetify.breakpoint.smAndDown"
            class="body-1 back-btn__text"
          >
            {{ $t('authForm.back') }}
          </span>
        </div>
      </VBtn>
    </VRow>
    <VRow justify="center">
      <VCol class="px-0 pb-0 text-center" cols="12">
        <span class="body-2 textPrimary--text">
          {{ $t('nightRiderLink.signUpStepSubtitle') }}
        </span>
      </VCol>
      <VCol cols="12" class="pa-0">
        <SNightRiderCardLinkForm
          ref="form"
          :show-primary-action="false"
          :account-phone="phone"
          :info-link-url="infoLinkUrl"
          :is-info-link-needed="true"
          @submit="onContinue"
        />
      </VCol>
      <VCol class="px-2 pt-0" cols="12">
        <button
          type="button"
          class="skip-button w-100"
          data-test="night-card-signup-skip"
          @click="onSkip"
        >
          <span class="skip-button__content d-flex align-items-center justify-space-between w-100">
            <span class="skip-button__text d-flex flex-column align-items-start text-left">
              <span class="skip-button__title body-bold">
                {{ $t('nightRiderLink.skipStepTitle') }}
              </span>
              <span class="skip-button__subtitle caption">
                {{ $t('nightRiderLink.skipStepSubtitle') }}
              </span>
            </span>
            <VIcon class="skip-button__icon flex-shrink-0">
              mdi-arrow-right
            </VIcon>
          </span>
        </button>
      </VCol>
      <VCol class="px-2 pb-3 pt-2" cols="12">
        <VBtn
          class="w-100 border-radius-8"
          dark
          large
          color="brandingPrimary"
          data-test="night-card-signup-next"
          @click="onNextClick"
        >
          <span class="button">{{ $t('general.next') }}</span>
        </VBtn>
      </VCol>
    </VRow>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SignUpNightCardStep',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import SNightRiderCardLinkForm from '@slg/web-customer-shared/src/components/nightRider/SNightRiderCardLinkForm.vue';

defineProps({
  phone: {
    type: String,
    default: '',
  },
  infoLinkUrl: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['skip', 'continue']);

const form = ref<any>(null);

function onSkip() {
  if (form.value && typeof form.value.reset === 'function') {
    form.value.reset();
  }
  emit('skip');
}

async function onNextClick() {
  if (form.value && typeof form.value.submitFromParent === 'function') {
    await form.value.submitFromParent();
  }
}

function onContinue(payload: any) {
  emit('continue', {
    nightRiderCardDetailsFormDTO: {
      cardNumber: payload.cardNumber,
      phone: payload.phone,
      firstName: payload.firstName,
      lastName: payload.lastName,
    },
  });
}
</script>

<style lang="scss" scoped>
.skip-button {
  display: block;
  border: none;
  border-radius: 16px;
  background-color: #e2e2e2;
  padding: 4px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #d6d6d6;
  }

  &:focus-visible {
    outline: 2px solid var(--v-secondary-base);
    outline-offset: 2px;
  }
}

.skip-button__content {
  min-height: 40px;
}

.skip-button__text {
  padding-right: 12px;
}

.skip-button__title {
  display: block;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #252525;
}

.skip-button__subtitle {
  display: block;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #767676;
}

.skip-button__icon {
  font-size: 24px;
  color: #64666B;
}
</style>
